import * as React from 'react';
import { baseUrl } from '../baseUrl';
import { styled} from '@mui/material/styles';
import {useTheme} from '@mui/material';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
// import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import PlusOneIcon from '@mui/icons-material/PlusOne';
// import DeleteIcon from '@mui/icons-material/Delete';
import Songbar from './Songbar';
import Menu from '@mui/material/Menu';
import { useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
// import AccountCircle from '@mui/icons-material/AccountCircle';
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
// import InputBase from '@mui/material/InputBase';
// import Badge from '@mui/material/Badge';
// import { generateUtilityClass } from '@mui/material';
// import Container from '@mui/material/Container';
// import PropTypes from 'prop-types';
// import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import { DialogContent } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { Link } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { DataGrid } from '@mui/x-data-grid';
// import Switch from '@mui/material/Switch';
import Privacy from './Privacy';
import Footer from './Footer';
// import MyplayerLogo from '../images/MyPlayerLogo.png';
import EditNotificationsOutlinedIcon from '@mui/icons-material/EditNotificationsOutlined';
import { useLocation } from 'react-router-dom';
// import { MuiColorInput} from "mui-color-input";
import { HexColorPicker } from "react-colorful";
import InputColor from 'react-input-color';
import BannerImage from './BannerImage';

// const themeOptions = {
//     palette: {
//       type: 'light',
//       primary: {
//         main: '#ff3300fa',
//       },
//       secondary: {
//         main: 'rgb(0, 0, 0)',
//       },
//     },
//   };

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        flexGrow: 1,
        padding: theme.spacing(0),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: `-${drawerWidth}px`,
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        }),
    }),
);

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    backgroundColor: theme.palette.primary.main,
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'center',
}));

const drawerWidth = 200;
const sidebar_icon = [LeaderboardOutlinedIcon,HomeOutlinedIcon, NotificationAddOutlinedIcon, PersonOutlineOutlinedIcon, CategoryOutlinedIcon,EditNotificationsOutlinedIcon]

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });


export default function Homescreen() {
    let device_id = "ebb888bb";
    const location = useLocation();
    const { username } = location.state || '';
    const {loginStatus} = location.state || false;
    useEffect(() => {
        if(loginStatus){
            onLoad()
            bannerImage()
        }
        else {
            navigate('/cms');
        }
    }, []);
    // const theme = useTheme();
    // const theme = createTheme(themeOptions);
    const [open, setOpen] = useState(false);
    const [addArtist,setOpenAddArtist]= useState(false);
    const [addGenre,setOpenAddGenre] = useState(false);
    const [drawerOpen, setDraweropen] = useState(false);
    const navigate = useNavigate();
    const [selectedLanguage, setSelectedLanguage] = useState({ language_id: 1, title: "Hindi" }); // Initialize with your default value
    const [homedata, setHomedata] = useState([]);
    const [Lang, setLang] = useState([]);
    const [loading, setLoading] = useState(true);
    const [video_id, setVideo_id] = useState('')
    const [tablename,setTablename] = useState('')
    const [addCategory, setAddCategory] = useState('')
    const [Title, setTitle] = useState('')
    const [subTitle,setSubtitle] = useState('');
    // const [checked, setChecked] = useState(false);
    // const [deleteCategoryOpen,setDeleteCategoryOpen] = useState(false);
    const [enableCategory,setEnablecategory] = useState(false);
    const [disableCategory,setDisablecategory] = useState(false);
    const [openaddlanguage,setOpenAddLanguage] = useState('');
    const [languagename,setLanguageName] = useState('');
    const [colorcode,setColorCode] = useState("#123123");
    const [value, setValue] = React.useState({});
    const [artist,setArtist] = useState('');
    const [genre,setGenre] = useState('');
    const [artistName,setArtistName] = useState('');
    const [genreName,setGenreName] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const [genreCategory,setGenreCategory] = useState([]);
    const [bannerimage,setBannerimage] = useState([]);
    const [selectedImage,setSelectedImage] = useState('');
    const [OpenBannerimage,setOpenBannerimage] = useState(false);
    const [NewBannerimage,setNewBannerimage] = useState();

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const handleLogout = async () => {
        try {
            if (loginStatus) {
                navigate('/cms');
                // setLogoutStatus('Logout successful');
            } else {
                // setLogoutStatus('Logout unsuccessful');
                alert("Logout unsuccessful")
                // window.location.reload(true)
            }
        } catch (error) {
            alert("An error occurred during logout")
            console.error('Error:', error);
            //   setLogoutStatus('An error occurred during logout');
        }
    }

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleLogout}>LogOut</MenuItem>
            {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
        </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <LogoutIcon />
                </IconButton>
                <p>Profile</p>
            </MenuItem>
        </Menu>
    );


    const handleLanguageChange = async (event) => {
        try {
            if (event.target.value === 'Add_language'){
                setOpenAddLanguage(true)
                return
            }
            const newValue = Lang.find((lang) => lang.language_id === event.target.value);
            setSelectedLanguage(newValue);

            const addLanguageResponse = await axios.post(`${baseUrl}add_language`, { device_id: device_id, language: [newValue.language_id] });
            console.log(addLanguageResponse);
            if (addLanguageResponse.data.status.code === 200) {
                const homeDataResponse = await axios.post(`${baseUrl}homedata`, { device_id: device_id, backend: "False" });
                const home = homeDataResponse.data;
                setHomedata(home)

            }
            else {
                console.error('Error:', addLanguageResponse);
                alert('An error occurred during add_language API call');
            }
        }
        catch (error) {
            console.error('Error:', error);
            alert('An error occurred during API call');
        }
    };

    const handleClickOpen = async (category) => {
        // console.log(category);
        if (category !== 'Artist' && category !== 'Genres'){
        // setCategory(category)
        setTablename(category);
        setOpen(true);
        }
        else{
            if (category !== 'Genres'){
                setTablename(category);
                setOpenAddArtist(true);  
            }
            else{
                setTablename(category);
                setOpenAddGenre(true); 
                try {
                    const response = await axios.get(`${baseUrl}allGenrecategory`);
                    const data = await response.data.data;
                    const category = data.map((item) => ({ category_name: item.category_name,}));
                    setGenreCategory(category);
                } catch (error) {
                    console.error('Error fetching genre categories:', error);
                }
            }
        }
    };

    const handleVideoIdChange = (event) => {
        setVideo_id(event.target.value);
    };

    const handleAdd = async () => {
        setOpen(false);
        try {
            const response = await axios.post(`${baseUrl}addsongs`, { "video_id": video_id, 'language_id': selectedLanguage.language_id, 'table_name': tablename });
            const data = await response.data;
            if (data.status.code === 200) {
                 window.location.reload(true);
            }
        }
        catch(e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
    };

    // const handleCancel = () => {
    //     setOpen(false);
    //     setVideo_id('')
    // }

    const handleArtistNameChange = async(event) =>{
        setArtistName(event.target.value)
    }

    const handleArtistChange = async(event) =>{
        // setArtist(event.target.files[0]);
        // setArtist(URL.createObjectURL(event.target.files[0]))
        const file = event.target.files[0];

        if (file) {
            const validExtensions = ['png','jpg','jpeg','webp'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!validExtensions.includes(fileExtension)) {
                alert('Please upload a .webp image only.');
            } else {
                setArtist(file);
            }
        }
    };

    const config = {     
        headers: { 'Content-Type': 'multipart/form-data' }
    };

    const formData = new FormData();
    formData.append('image', artist);
    formData.append('name', artistName);
    formData.append('language_id', selectedLanguage.language_id);
    
    const handleAddArtist = async() =>{
        setOpenAddArtist(false)
        try {
            const response = await axios.post(`${baseUrl}addArtist`, formData, config);
            const data = await response.data;
            if (data.status.code === 200) {
                 window.location.reload(true);
            }else{
                alert(data.status.message)
            }
        }
        catch(e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }

    };

    // const handleCancelArtist = () =>{
    //     setOpenAddArtist(false);
    //     setArtist('');
    // };

    const handleGenreNameChange = (event) =>{
        setGenreName(event.target.value)
    };

    const handleGenreChange = async(event) =>{
        const file = event.target.files[0];

        if (file) {
            const validExtensions = ['png','jpg','jpeg','webp'];
            const fileExtension = file.name.split('.').pop().toLowerCase();

            if (!validExtensions.includes(fileExtension)) {
                alert('Please upload a valid image format.');
            } else if(file.size / 1024 > 11){
                alert('Image size should be less then 10kb.')
            }
            else {
                setGenre(file);
            }
        }
    };

    // const handleColorCode = (newValue) => {
    //     setValue(newValue)
    // }

    const formDataGenre = new FormData();
    formDataGenre.append('image', genre);
    formDataGenre.append('title', genreName);
    formDataGenre.append('color_code',value);
    formDataGenre.append('category_id',selectedLanguage.language_id);

    const handleAddGenre = async() =>{
        setOpenAddGenre(false)
        try {
            const response = await axios.post(`${baseUrl}addGenres`, formDataGenre, config);
            const data = await response.data;
            if (data.status.code === 200) {
                 window.location.reload(true);
            }
        }
        catch(e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }


    };

    const handleCancelGenre = () =>{
        setOpenAddGenre(false);
        setGenre('');
    };


    const handleClickDisable = (category) =>{
        setTablename(category)
        setDisablecategory(true)
    };
    
    const handleClickEnable = (category) =>{
        setTablename(category)
        setEnablecategory(true)
    };

    // const handleDeleteClose = () =>{
    //     setEnablecategory(false)
    //     setDisablecategory(false)
    // };

    const handleDeleteOkay = async(type) =>{
        // console.log(type);
        try {
            if (type === 'type1'){
                const response = await axios.post(`${baseUrl}Enablecategory`, { "table_name": tablename,"type":1});
                const data = response.data;
                // console.log(data);
                if (data.status.code === 200) {
                    // window.location.reload(true);
                    setEnablecategory(false)
                    onLoad();
                    // setDisablecategory(false)
                }
            }else{
                const response = await axios.post(`${baseUrl}Enablecategory`, { "table_name": tablename,"type":2});
                const data = response.data;
                // console.log(data);
                if (data.status.code === 200) {
                    // window.location.reload(true);
                    setDisablecategory(false)
                    onLoad();
                    // setEnablecategory(false)
                }
            }
        }
        catch(e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
    };

    // const handleCategory = () => {
    //     setAddCategory(true);
    // };

    // const handleCancelCategory = () => {
    //     setAddCategory(false)
    // };

    // const handleCategorychange = (event) => {
    //     setTitle(event.target.value);
    // };

    const handleAddCategory = async () => {
        try {
            const response = await axios.post(`${baseUrl}addcategory`, { title: Title,subTitle:subTitle});
            const data = await response.data;
            if (data.status.code === 200) {
                // window.location.reload(true);
                setAddCategory(false);
                onLoad();
            }else{
                alert(data.status.message)
                setAddCategory(false);
            }
        }
        catch (e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
            setAddCategory(false);
        }
    };

    // const handleAddLang = () =>{
    //     setOpenAddLanguage(true);
    // };

    // const handleCancelLanguage = async() =>{
    //     setOpenAddLanguage(false);
    // };

    // const handleAddLanguagechange = async(event) => {
    //     setLanguageName(event.target.value);
    // };

    const handleAddColorcodechange = (newColor) => {
        setColorCode(newColor);
    };

    const handleAddLanguage = async () =>{
        setOpenAddLanguage(false);
        try{
            const response = await axios.post(`${baseUrl}language_add`, { language:languagename,color:colorcode })
            const data = await response.data;
            if (data.status.code === 200) {
                window.location.reload(true);
            }
        }
        catch (e) {
            <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    Error occurred — <strong>check it out!</strong>
                </Alert>
            </Stack>
        }
    };

    const handleSequenceChange = async(event,category) =>{
        // console.log(event.target.value);
        // console.log(category);
        // alert('hahhahah')
        // setTablename(category)
        const newValue = event.target.value;
        // console.log('jk:',newValue);
        if (parseFloat(newValue) < 0){
            alert('Insert proper sequence number.');
            return;
        }else{
            try{
                const response = await axios.post(`${baseUrl}changeCategorySequence`, {category_name:category,sequence:newValue })
                const data = response.data;
                if (data.status.code === 200) {
                    onLoad()
                    alert("sequence update")
                    // window.location.reload(true);
                }else{
                    alert(data.status.message)
                }
            }
            catch (e) {
                console.log('Error is:',e);
        }
        }
    };

    // const handleBannerimage = () =>{
    //     setOpenBannerimage(true)
    // };

    // const handleCloseBannerimage = () =>{
    //     setOpenBannerimage(false)
    // };

    const formDataBannerimage = new FormData();
    formDataBannerimage.append('image', NewBannerimage);

    const handleAddBannerimage = async() =>{
        // console.log(NewBannerimage);
        if (NewBannerimage) {
            const validExtensions = ['png','jpg','jpeg','webp'];
            const fileExtension = NewBannerimage.name.split('.').pop().toLowerCase();
            
            if (!validExtensions.includes(fileExtension)) {
                alert('Please upload a valid image format.');
                return;
            } else if(NewBannerimage.size / 1024 > 11){
                alert('Please upload an image with a size less than 10 KB.');
                return;
            }else{
                try {
                    const response = await axios.post(`${baseUrl}addPosterImage`, formDataBannerimage, config);
                    // console.log('fgngh:',response.data);
                    const data = response.data;
                    if (data.status.code === 200) {
                        setOpenBannerimage(false)
                        window.location.reload(true);
                    }else{
                        setOpenBannerimage(false)
                        alert(data.status.message)
                    }
                }
                catch(e) {
                    console.log('Error is:',e);
                }
            }}
    };

    const carousel = (searchResult) => {
        return (
            <Box key={searchResult.category} sx={{ marginLeft: '200px', display: 'flex', flexDirection: 'column', bgcolor:'white', gap: '5px' }}>
                <Divider />
                <Box sx={{ overflow: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'space-between', marginLeft: '5px' }}>
                    <Typography variant="h5" color="text.primary" align="left">
                        {searchResult.category}
                    </Typography>
                    <Box sx={{display: 'flex',justifyContent: 'space-between'}}>
                    {searchResult.category !== 'Genres' && (
                    <>
                    <TextField variant="standard" label = "Sequence" size = 'small' style={{width:70}}  id="sequence" defaultValue={searchResult.sequence} onBlur={(event) => {handleSequenceChange(event,searchResult.category)}}/>
                    {searchResult.is_enabled === true ? (
                            // aria-label="delete" size="large" color="primary"
                        <Button onClick={() => handleClickDisable(searchResult.category)} variant="outlined">     
                            {/* <DeleteIcon fontSize="inherit"/> */}
                            ENABLE
                        </Button>
                    ) : (<Button onClick={() => handleClickEnable(searchResult.category)} variant="outlined">DISABLE</Button> )}
                    </>
                    )}
                    <Button onClick={() => handleClickOpen(searchResult.category)} variant="outlined" startIcon={<PlusOneIcon />}>
                        ADD
                    </Button>
                    </Box>
                </Box>
                <Songbar searchResult={searchResult} />
                <Divider />
            </Box>
        );
    };

    const boxes = homedata && homedata?.data && homedata?.data?.map((data) => {
        return Object.keys(data).map((key) => (
            carousel(data[key])
        ))
    });

    const onLoad = async () => {
        try {
            const response = await axios.post(`${baseUrl}get_language`, { "device_id": device_id });
            const data = await response.data.data;
            const titles = data.map((item) => ({ language_id: item.language_id, title: item.title, }));
            setLang(titles);
            const addLanguageResponse = await axios.post(`${baseUrl}add_language`, { device_id: device_id, language: [selectedLanguage.language_id] });
            // console.log(addLanguageResponse.data);
            if (addLanguageResponse.data.status.code === 200) {
                const homeDataResponse = await axios.post(`${baseUrl}homedata`, { device_id: device_id, "backend": "False" });
                // console.log(homeDataResponse);
                const home = homeDataResponse.data;
                setHomedata(home)
            }
            else {
                console.error('Error:', addLanguageResponse.data.status.message);
                alert('An error occurred during homedata API call.');
            }
            setLoading(false);
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred during data fetching.');
            setLoading(false);
        };
    };

    const bannerImage = async() =>{
        const response = await axios.get(`${baseUrl}getPosterImages`)
        const data = response.data.data
        const image = data.map((item) => ({ id: item.id, image: item.image}))
        const select = response.data.todayImage
        setBannerimage(image)
        setSelectedImage(select)
    };

    const carousel_2 = () => {
        return(
                <Box sx={{ marginLeft: '200px', display: 'flex', flexDirection: 'column', bgcolor:'white', gap: '5px' }}>
                    <Divider />
                    <Box sx={{ overflow: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'start', justifyContent: 'space-between', marginLeft: '5px' }}>
                        <Typography variant="h5" color="text.primary" align="left">
                            Banner Image
                        </Typography>
                        <Box sx={{display: 'flex',justifyContent: 'space-between'}}>
                        <Button onClick={()=>{setOpenBannerimage(true)}} variant="outlined" startIcon={<PlusOneIcon />}>
                            ADD
                        </Button>
                        </Box>
                    </Box>
                    <BannerImage Images={bannerimage} selectedImage={selectedImage}/>
                    <Divider />
                </Box>
            )
    };


    const columns = [
        { field: 'id', headerName: 'User ID', width: 100, sortable: false, },
        { field: 'email_id', headerName: 'Email ID ', width: 200, sortable: false },
        { field: 'device_id', headerName: 'Device ID', width: 225, sortable: false }
    ];

    const handleDrawerToggle = () => {
        setDraweropen(!drawerOpen);
    };

    const currencies = [
            {
              value: 'USD',
              label: '$',
            },
            {
              value: 'EUR',
              label: '€',
            },
            {
              value: 'BTC',
              label: '฿',
            },
            {
              value: 'JPY',
              label: '¥',
            },
    ];

    return (
        <>
            {/* add new song */}
            <Dialog open={open}  PaperProps={{ style: { maxWidth: '500px', width: '100%' } }}>
                <DialogTitle>Add Song</DialogTitle>
                <DialogContent>
                    <TextField 
                    autoFocus 
                    required 
                    id="url" 
                    label="YouTube Video Url/Id" 
                    name = "url"
                    type="url"
                    variant="standard" 
                    fullWidth
                    margin="dense"
                    value={video_id} 
                    onChange={handleVideoIdChange}
                    />
                    {/* <TextField
                            id="standard-read-only-input"
                            label="Language"
                            defaultValue={selectedLanguage.title}
                            fullWidth
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="standard"
                        /> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {setOpen(false);setVideo_id('')}}>CANCEL</Button>
                    <Button onClick={handleAdd}>ADD</Button>
                </DialogActions>
            </Dialog>

            {/* add artist */}
            <Dialog open={addArtist}  PaperProps={{ style: { maxWidth: '500px', width: '100%' } }}>
                <DialogTitle>Add Artist</DialogTitle>
                <DialogContent>
                <TextField 
                    autoFocus 
                    required 
                    id="name" 
                    label="Artist Name" 
                    name = "name"
                    type="name"
                    variant="standard" 
                    fullWidth
                    margin="dense"
                    value={artistName} 
                    onChange={handleArtistNameChange}
                    />
                    <Button component="label" variant="contained" startIcon={<CloudUploadIcon />} sx={{marginTop:'10px'}}>
                        {artist ? artist.name : 'Upload Artist Image'}
                        <VisuallyHiddenInput type="file" onChange={handleArtistChange}/>
                    </Button>
                    <Typography variant="body2" align="left">
                        *image size should be less then 10kb.
                    </Typography>
                        {/* <input type="file" onChange={handleArtistChange} style={{width:'100%'}}/> */}
                   
                    {/* <TextField
                            id="standard-read-only-input"
                            label="Language"
                            defaultValue={selectedLanguage.title}
                            fullWidth
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="standard"
                        /> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {setOpenAddArtist(false);setArtist('')}}>CANCEL</Button>
                    <Button onClick={handleAddArtist}>ADD</Button>
                </DialogActions>
            </Dialog>

            {/* add genre */}
            <Dialog open={addGenre}  PaperProps={{ style: { maxWidth: '500px', width: '100%' } }}>
                <DialogTitle>Add Genres</DialogTitle>
                <DialogContent>

                    <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}>
                        {artist ? artist.name : 'Upload Genre Image'}
                        <VisuallyHiddenInput type="file" onChange={handleGenreChange}/>
                    </Button>
                    <Typography variant="body2" align="left">
                        *image size should be less then 10KB
                    </Typography>
                    {/* <input type="file" onChange={handleArtistChange} style={{width:'100%'}}/> */}
                    <TextField 
                        autoFocus 
                        required 
                        id="name" 
                        label="Genre Name" 
                        name = "name"
                        type="name"
                        variant="standard" 
                        fullWidth
                        margin="dense"
                        value={genreName} 
                        onChange={handleGenreNameChange}
                    />
                   <InputColor initialValue="#fd5806" onChange={setValue} placement="center" style={{width:50 ,height:30,marginTop:10,zIndex: 1000}}/>
                   <TextField
                        id="name"
                        fullWidth
                        margin='dense'
                        select
                        label="Select Genre Category"
                        // defaultValue="EUR"
                        // helperText="Genre"
                        variant="standard"
                        // onChange={()=>{}}
                        // value={"selected"}
                        >
                        <Button>Add New Genre Category</Button>
                        {genreCategory.map((option) => (
                            <MenuItem key={option.category_name} value={option.category_name}>
                                {option.category_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelGenre}>CANCEL</Button>
                    <Button onClick={handleAddGenre}>ADD</Button>
                </DialogActions>
            </Dialog>

            {/* enable category */}
            <Dialog open={enableCategory} >
                <DialogTitle>Enable Category</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to enable this category?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {setEnablecategory(false)}}>Cancel</Button>
                    <Button onClick={()=>{handleDeleteOkay('type1')}}>Okay</Button>
                </DialogActions>
            </Dialog>

            {/* disable category */}
            <Dialog open={disableCategory} >
                <DialogTitle>Disable Category</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to disable this category?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{setDisablecategory(false)}}>Cancel</Button>
                    <Button onClick={()=>{handleDeleteOkay("type2")}}>Okay</Button>
                </DialogActions>
            </Dialog>

            {/* add category */}
            <Dialog open={addCategory}  PaperProps={{ style: { maxWidth: '500px', width: '100%' } }}>
                {/* <div style={{ height: '250px', width: '500px' }}> */}
                <DialogTitle>Add Category</DialogTitle>
                <DialogContent>
                    {/* <TextField
                        id="name"
                        fullWidth
                        margin='dense'
                        select
                        label="Select"
                        // defaultValue="EUR"
                        helperText="Category"
                        variant="standard"
                        onChange={()=>{}}
                        value={"selected"}
                        >
                        <Button>Add Category</Button>
                        {currencies.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField> */}
                    <TextField id="name" label="Title" margin="dense" type="name" fullWidth autoFocus variant="standard" onChange={(event) => {(setTitle(event.target.value))}} />
                    <TextField id="name" label="SubTitle" margin="dense" type="name" fullWidth autoFocus variant="standard" onChange={(event) => {(setSubtitle(event.target.value))}} />
                </DialogContent>
                <DialogActions >
                    <Button onClick={() => {(setAddCategory(false))}}>CANCEL</Button>
                    <Button onClick={handleAddCategory}>ADD</Button>
                </DialogActions>
                {/* </div> sx={{ bottom: 5, right: 5, position: 'absolute' }} */}
            </Dialog>

            {/* insert banner image */}
            <Dialog open={OpenBannerimage} PaperProps={{ style: { maxWidth: '500px', width: '100%' } }}>
                <DialogTitle>Add Banner Image</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus={true}
                        label="Banner Image"
                        variant="standard"
                        fullWidth
                        value={NewBannerimage?.name}
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{
                            shrink: !!NewBannerimage,
                        }}
                    />

                    <Button component="label" variant="contained" startIcon={<CloudUploadIcon />} sx={{ marginTop: '10px' }}>
                        {'Upload Banner Image'}
                        <VisuallyHiddenInput type="file" onChange={(event) => {setNewBannerimage(event.target.files[0]) }} />
                    </Button>
                    <Typography variant="body2" align="left">
                        *image size should be less then 10KB.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setOpenBannerimage(false)}}>CANCEL</Button>
                    <Button onClick={handleAddBannerimage}>ADD</Button>
                </DialogActions>
            </Dialog>


            <Box sx={{ flexGrow: 1 }}>
                <CssBaseline />
                <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={drawerOpen}>
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerToggle}
                            edge="start"
                            sx={{ mr: 0, ...(open && { display: 'none' }) }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" noWrap component="div">
                            YaYa Player
                        </Typography>

                        <Box sx={{ flexGrow: 1 }} />
                        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>



                            <Box sx={{ width: 150 }}>
                                <FormControl variant="standard" sx={{ m: -1, minWidth: 120 }}>
                                    <InputLabel id="demo-simple-select-standard-label">
                                        Language
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        label="Language"
                                        value={selectedLanguage.language_id}
                                        onChange={handleLanguageChange}
                                    >
                                        {Lang.map((language) => (
                                            <MenuItem key={language.language_id} value={language.language_id}>
                                                {language.title}
                                            </MenuItem>
                                        ))}
                                        {/* <Button onClick={()=>{setOpenAddLanguage(true)}}>ADD Language</Button> */}
                                        <MenuItem value={"Add_language"}>
                                            <Button variant="contained">
                                                {"ADD Language"}
                                            </Button>
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>

                            <Typography variant="h6" noWrap component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                {username}
                            </Typography>

                            <IconButton
                                size="large"
                                edge="end"
                                aria-label="account of current user"
                                aria-controls={menuId}
                                aria-haspopup="true"
                                onClick={handleProfileMenuOpen}
                                color="inherit"
                            >
                                <LogoutIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="show more"
                                aria-controls={mobileMenuId}
                                aria-haspopup="true"
                                onClick={handleMobileMenuOpen}
                                color="inherit"
                            >
                                <MoreIcon />
                            </IconButton>
                        </Box>

                    </Toolbar>
                    <Dialog open={openaddlanguage}>
                        <div style={{ height: '200', width: '100%' }}>
                            <DialogTitle>Add Language</DialogTitle>
                            <DialogContent>
                                <TextField id="language" label="Language" margin="dense" type="name" fullWidth autoFocus variant="standard" onChange={(event)=>{setLanguageName(event.target.value)}} />
                                <TextField id="colorcode" label="Color Code" margin="dense" type="name" defaultValue={'#00b7ff'} fullWidth autoFocus variant="standard" value={colorcode} />
                                <HexColorPicker value={colorcode} onChange={handleAddColorcodechange} />

                            </DialogContent>
                            <DialogActions>
                                <Button onClick={()=>{setOpenAddLanguage(false)}}>CANCEL</Button>
                                <Button onClick={handleAddLanguage}>ADD</Button>
                            </DialogActions>
                        </div>
                    </Dialog>
                </AppBar>
                {renderMobileMenu}
                {renderMenu}

                <Drawer
                    variant="persistent"
                    anchor="left"
                    open={drawerOpen}
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                        },
                    }}
                >
                    <DrawerHeader>
                        {/* <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton> */}
                        <img style={{ width: '50px', height: '50px', marginRight: '1px' }} src={"https://beeitech.com/images/logo/appicon.png"} alt='logo' />
                    </DrawerHeader>
                    <Divider />
                    <List>

                        <ListItem key="Dashboard" disablePadding>
                            <ListItemButton component={Link} to="/cms/dashboard" state={{ username: username, loginStatus: loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[0])}
                                </ListItemIcon>
                                <ListItemText primary="Dashboard" />
                            </ListItemButton>
                        </ListItem>

                        <ListItem class="drawer-select" key="Home" disablePadding>
                            <ListItemButton onClick={() => window.location.reload(true)}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[1])}
                                </ListItemIcon>
                                <ListItemText primary="Home Screen" />
                            </ListItemButton>
                        </ListItem>

                        
                        <ListItem key="Category" disablePadding>
                            <ListItemButton onClick={() => {(setAddCategory(true))}}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[4])}
                                </ListItemIcon>
                                <ListItemText primary="Add Category" />
                            </ListItemButton>
                        </ListItem>

                        {/* <ListItem key="Send Notification" disablePadding>
                            <ListItemButton component={Link} to="/cms/sendnotifications" state={{ username: username,loginStatus:loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[2])}
                                </ListItemIcon>
                                <ListItemText primary="Send Notification" />
                            </ListItemButton>
                        </ListItem> */}

                        <ListItem key="Users" disablePadding>
                            <ListItemButton component={Link} to="/cms/userpage" state={{ username: username, loginStatus: loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[3])}
                                </ListItemIcon>
                                <ListItemText primary="Users" />
                            </ListItemButton>
                        </ListItem>


                        <ListItem key="Notifications Config" disablePadding>
                            <ListItemButton component={Link} to="/cms/notificationsconfig" state={{ username: username, loginStatus: loginStatus }}>
                                <ListItemIcon>
                                    {React.createElement(sidebar_icon[5])}
                                </ListItemIcon>
                                <ListItemText primary="Notifications Config" />
                            </ListItemButton>
                        </ListItem>

                    </List>
                    <Divider />
                    <Privacy />


                    {/* <Dialog open={openNotification} onClose={handleCancelNotification}>
                        <div style={{ height: '100vh', width: '100%' }}>
                            <div style={{ height: 550 }}>
                                <DataGrid
                                    rows={row}
                                    columns={columns}
                                    checkboxSelection
                                    onRowSelectionModelChange={(newRowSelectionModel) => {
                                        setUserselected(newRowSelectionModel);
                                    }}
                                />
                            </div>
                            <div style={{ height: 80 }}>
                                <DialogContent>
                                    
                                    <TextField id="standard-basic" label="Title" defaultValue="Listen Top Songs Only On MyPlayer!" fullWidth autoFocus variant="standard" value={title} onChange={handletitleChange} />
                                    <TextField id="standard-basic" label="Body" defaultValue="MyPlayer" fullWidth autoFocus variant="standard" value={body} onChange={handleBodyChange} />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCancelNotification}>CANCEL</Button>
                                    <Button onClick={handleSend}>Send</Button>
                                </DialogActions>

                            </div>
                        </div>
                    </Dialog> */}


                </Drawer >

                <div>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                            <CircularProgress style={{ 'color': '#ff3300e1' }} />
                        </Box>
                    ) : (
                        <Main open={drawerOpen}>
                            <DrawerHeader />
                            {/* <Box component="main" sx={{ flexGrow: 1 }}> */}
                            {/* <Toolbar /> */}
                            {carousel_2()}
                            {boxes}
                            <Footer />
                            {/* </Box> */}
                        </Main>
                    )}
                </div>
            </Box>
        </>
  );
}

// onClick={() => { handleUser(); handleSendNotification(); }}